(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class FilterCollapseToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[ref="toggle"]');
      this.storageKey = `filters-collapsed-${this.dataset.sectionId}-${this.dataset.defaultCollapsed}`;
      this.wrapper = this.closest('.collection-wrapper');
      this.wrapper?.classList.add('filters-collapsible'); // ensure layout is active after AJAX re-render

      this.render(this.isCollapsed(), false);

      if (!this.bound) {
        this.button.addEventListener('click', () => this.toggle());
        this.bound = true;
      }
    }
    isCollapsed() {
      let stored = null;
      try { stored = localStorage.getItem(this.storageKey); } catch (e) {}
      if (stored === null) return this.dataset.defaultCollapsed === 'true';
      return stored === '1';
    }
    toggle() { this.render(!this.hasAttribute('data-collapsed'), true); }
    render(collapsed, persist = true) {
      this.wrapper?.classList.add('filters-collapsible');
      this.wrapper?.classList.toggle('filters-collapsed', collapsed);
      this.toggleAttribute('data-collapsed', collapsed);
      this.button?.setAttribute('aria-expanded', String(!collapsed));
      if (persist) {
        try { localStorage.setItem(this.storageKey, collapsed ? '1' : '0'); } catch (e) {}
      }
    }
  }
  if (!customElements.get('filter-collapse-toggle')) {
    customElements.define('filter-collapse-toggle', FilterCollapseToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
